import React from 'react';

import classNames from 'classnames';
import {useSelector} from 'react-redux';

import {LoadingOverlay} from 'components/loadingOverlay/loadingOverlay';

import {PlacingOrderScreen} from 'desktop/components/placingOrderScreen/placingOrderScreen';

import {STEPS} from '../../constants/checkout';
import {PAYMENTS} from '../../constants/paymentStep';
import {getIsCompleteOrderPlacing} from '../../store/selectors/completeOrder/completeOrder';
import {getCurrentStep} from '../../store/selectors/currentStep/currentStep';
import {isDeliveryStepLoaded} from '../../store/selectors/deliveryStep/deliveryStep';
import {
    getIsEditingOneStepPayment,
    getNameSelectedMethod,
} from '../../store/selectors/paymentStep/paymentStep';
import {getShippingMethodsStatus} from '../../store/selectors/shippingMethods/shippingMethods';
import {DeliveryFormWrapperConnected} from '../deliveryFormWrapper/deliveryFormWrapper';

import {useUpdatePaymentMethod} from './hooks/useUpdatePaymentMethod';
import {useUpdateShippingMethod} from './hooks/useUpdateShippingMethod';
import {PAYMENTS_COMPONENTS} from './paymentComponents/paymentComponents';
import {PaymentEmpty} from './paymentComponents/paymentEmpty/paymentEmpty';

import {PaymentMethodEdit} from './paymentComponents/paymentMethodEdit/paymentMethodEdit';

import s from './oneStep.scss';

/**
 * One step checkout
 */
export const OneStep = () => {
    const isStepLoaded = useSelector(isDeliveryStepLoaded);
    const shippingMethodStatus = useSelector(getShippingMethodsStatus);
    const selectedMethod = useSelector(getNameSelectedMethod);
    const isPlacingOrderPrimer = useSelector(getIsCompleteOrderPlacing);
    const isEditingOneStepPayment = useSelector(getIsEditingOneStepPayment);

    // Check current step before rendering Primer components
    // to create session once and avoid duplicate buttons
    const currentStep = useSelector(getCurrentStep);

    useUpdateShippingMethod();
    useUpdatePaymentMethod();

    const isLoading = !isStepLoaded || shippingMethodStatus === 'PENDING';

    return (
        <>
            {isLoading && <LoadingOverlay aria-label="Loading delivery step" />}

            <div className={classNames({[s.hide]: isEditingOneStepPayment})}>
                <DeliveryFormWrapperConnected isUserWithAddress />
                {isLoading || currentStep !== STEPS.PAYMENT_STEP ? (
                    <PaymentEmpty />
                ) : (
                    PAYMENTS_COMPONENTS[selectedMethod as PAYMENTS]
                )}
            </div>

            {isEditingOneStepPayment && <PaymentMethodEdit />}

            {isPlacingOrderPrimer && <PlacingOrderScreen />}
        </>
    );
};
